const CHUNK_RELOAD_KEY = 'agrosdr:last-chunk-reload-at'
const RELOAD_COOLDOWN_MS = 30_000

export function installChunkReloadGuard() {
  if (typeof window === 'undefined') return

  window.addEventListener('error', (event) => {
    if (isChunkLoadError(event.error ?? event.message)) {
      reloadOnceForFreshAssets()
    }
  })

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason)) {
      reloadOnceForFreshAssets()
    }
  })
}

function reloadOnceForFreshAssets() {
  const now = Date.now()
  const lastReloadAt = Number(
    window.sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? '0'
  )

  if (
    Number.isFinite(lastReloadAt) &&
    now - lastReloadAt < RELOAD_COOLDOWN_MS
  ) {
    return
  }

  window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now))
  window.location.reload()
}

function isChunkLoadError(error: unknown) {
  const message = errorMessage(error).toLowerCase()
  if (!message) return false

  return [
    'chunkloaderror',
    'loading chunk',
    'failed to fetch dynamically imported module',
    'importing a module script failed',
    'unable to preload css',
    'dynamically imported module',
  ].some((pattern) => message.includes(pattern))
}

function errorMessage(error: unknown) {
  if (typeof error === 'string') return error
  if (error instanceof Error) return `${error.name} ${error.message}`
  if (error && typeof error === 'object') {
    const record = error as Record<string, unknown>
    return [record.name, record.message, record.reason]
      .filter((part): part is string => typeof part === 'string')
      .join(' ')
  }
  return ''
}
